<template>
    <div class="common_container">
        <el-form ref="form" :model="form" label-width="80px" class="change-form">

            <el-row>
                <el-col :span="12">
                    <el-form-item label="标签">
                        <el-select v-model="form.key" placeholder="请选择" class="form-input">
                            <el-option v-for="item in list" :key="item.key" :label="item.key" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="环境">
                        <el-select v-model="form.envId" placeholder="请选择" class="form-input">
                            <el-option v-for="item in envList" :key="item" :label="getNameByDefault(+item, env)" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="参数名">
                        <el-input type="text" placeholder="请选择参数名" v-model="form.keys"   :disabled="type==='edit'" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="中文名">
                        <el-input type="text" placeholder="请选择中文名" v-model="form.cname" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="参数值">
                        <el-input type="textarea" placeholder="请选择参数值" v-model="form.value" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item>
                <el-button type="primary" size="small" @click="submit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import services from "./dictionary.service";
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            callback:Function,
            keyValue: String,
            envValue: String,
            row: Object
        },

        data() {
            return {
                formName:"form",
                form:{
                    key: '',
                    cname: '',
                    envId: '',
                    value: '',
                    keys: ''
                },
                envList: [0,1,2,3,4],
                list: [],
                // dictionary:{}
            }
        },
        created() {

            this.getDefaultParams()
            if(this.type == "edit"){
                this.$modal.title = "修改变更",
                    // console.log(this.row, 'ssssssssssssss', this.envValue)
                this.form = {
                    key: this.keyValue,
                    envId: +this.envValue,
                    cname: this.row.cname,
                    keys: this.row.key,
                    value: this.row.value
                }
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary2;
            },
            env() {
                return this.dictionary.env
            }
        },
        mounted(){
            // console.log(this.env);
        },
        methods: {
            getDefaultParams() {
                services.dictionaryList()
                    .then(res => {
                        this.list = res
                    })
                    .catch(err => this.$message.error(err.message))
            },

            submit(){
                let formName = this.formName;

                this.$refs[formName].validate((valid) => {
                    if(valid){
                        let params = this.getParams();
                        if(this.type == 'edit'){
                            this.updateChange(params);
                        }else{
                            this.addChange(params);
                        }
                    };
                    return valid;
                })
            },
            getParams(){
                let params = {
                    type: this.form.key,
                    env: this.form.envId,
                    value: this.form.value,
                    key: this.form.keys,
                    cname: this.form.cname
                };
                if (this.type === 'edit') {
                    params.method = 'update'
                } else {
                    params.method = 'add'
                }
                return params;
            },
            // 创建变更
            addChange(params){
                services.dictionaryAdd(params).then(res => {
                    this.$message.success("变更创建成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })

            },
            // 修改变更
            updateChange(params){
                services.dictionaryEdit(params).then(res => {
                    this.$message.success("变更修改成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },

            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

        }
    }
</script>

<style scoped>

</style>
